import { useMemo } from "react";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { LangstonParameterSchema } from "../LangstonParameterSchema";

const PHET_SIMULATION = "PHET_SIMULATION&TUVA_DATASET";
const WORKSHEET = "WORKSHEET";
const UNIVERSAL_EMBED_CONTENT_TYPES = ["ARTICLE", "BUNDLE"];

/**
 * Hook that filters content type values based on experiment flags and context.
 * - Filters PhET Simulations based on the phet_simulation_search_filter experiment.
 * - Filters to only Articles and Text Sets when in universal embed mode.
 * - Filters out Worksheets for students (not intended for student use).
 *
 * @param isUniversalEmbed - Whether the search is rendered in universal embed mode
 * @returns {Array} Filtered array of content type values
 */
export const useContentTypeValues = (isUniversalEmbed = false) => {
  const [phetExperimentValue] = useGetUserExperimentSegment(
    "phet_simulation_search_filter",
  );
  const { isStudent } = useGetUserProperties();

  const contentTypeValues = useMemo(() => {
    const allValues = LangstonParameterSchema.content_types.values;
    const isPhetEnabled = phetExperimentValue === "on";

    return allValues.filter((contentType) => {
      if (isUniversalEmbed) {
        return UNIVERSAL_EMBED_CONTENT_TYPES.includes(contentType.value);
      }
      if (isStudent && contentType.value === WORKSHEET) {
        return false;
      }
      // Filter out PHET_SIMULATION if user is not in the experiment
      return contentType.value === PHET_SIMULATION ? isPhetEnabled : true;
    });
  }, [phetExperimentValue, isUniversalEmbed, isStudent]);

  return contentTypeValues;
};
